module.exports = __webpack_public_path__ + "img/s2s_logo.86767be1.png";